export class SearchCardMovementsRequest {
  numeroTarjeta: string;
  anio: number;
  mes: number;
  rubroId?: number;
  page?: number;
  size?: number;

  constructor(data: {
    numeroTarjeta: string;
    anio?: number;
    mes?: number;
    rubroId?: number;
    page?: number;
    size?: number;
  }) {
    this.numeroTarjeta = data.numeroTarjeta;
    this.rubroId = data.rubroId;
    this.anio = data.anio || new Date().getFullYear();
    this.mes = data.mes || new Date().getMonth()+1;
    this.page = data.page;
    this.size = data.size;
  }
}
